import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiRoutes } from './ApiRoutes';
import { Gt2ApiService } from './gt2-api.service';

/**
 * Photo library picker endpoints.
 * - mine: the tenant's own already-uploaded product/material photos (aggregate).
 * - gt:   the generic GT (GOD-curated) library, shared across tenants.
 * Both are gated server-side by their module and return { data: [...] }.
 * The bearer token is attached globally by AuthInterceptor.
 */
@Injectable({ providedIn: 'root' })
export class PhotoLibraryService {
  constructor(
    private http: HttpClient,
    private api: Gt2ApiService,
  ) {}

  public getMine(type: string, search: string): Observable<any> {
    return this.http.get<any>(
      this.api.createUrl(ApiRoutes.PHOTO_LIBRARY_MINE) +
        `?type=${encodeURIComponent(type)}&search=${encodeURIComponent(search)}`,
    );
  }

  public getGt(type: string, search: string): Observable<any> {
    return this.http.get<any>(
      this.api.createUrl(ApiRoutes.PHOTO_LIBRARY_GT) +
        `?type=${encodeURIComponent(type)}&search=${encodeURIComponent(search)}`,
    );
  }

  public applyFromUrl(
    modelType: string,
    modelUuid: string,
    url: string,
  ): Observable<any> {
    return this.http.post<any>(
      this.api.createUrl(ApiRoutes.PICTURE_UPLOAD_BY_URL),
      { model_type: modelType, model_uuid: modelUuid, url },
    );
  }
}
